/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Rule,
    RuleFromJSON,
    RuleFromJSONTyped,
    RuleToJSON,
} from './Rule';

/**
 * 
 * @export
 * @interface LoaFieldRule
 */
export interface LoaFieldRule {
    /**
     * 
     * @type {string}
     * @memberof LoaFieldRule
     */
    field?: string;
    /**
     * 
     * @type {Set<Rule>}
     * @memberof LoaFieldRule
     */
    rules?: Set<Rule>;
}

export function LoaFieldRuleFromJSON(json: any): LoaFieldRule {
    return LoaFieldRuleFromJSONTyped(json, false);
}

export function LoaFieldRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoaFieldRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field': !exists(json, 'field') ? undefined : json['field'],
        'rules': !exists(json, 'rules') ? undefined : (new Set((json['rules'] as Array<any>).map(RuleFromJSON))),
    };
}

export function LoaFieldRuleToJSON(value?: LoaFieldRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field': value.field,
        'rules': value.rules === undefined ? undefined : (Array.from(value.rules as Set<any>).map(RuleToJSON)),
    };
}

